import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckTutorial } from './providers/check-tutorial.service';
import { AuthGuard} from './services/auth-guard.service';
import {CompanyPageModule} from './pages/company/company/company.module';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'countries',
    loadChildren: () => import('./pages/countries/countries.module').then( m => m.CountriesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'country/:id',
    loadChildren: () => import('./pages/country/country.module').then( m => m.CountryPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'sectors',
    loadChildren: () => import('./pages/sectors/sectors.module').then( m => m.SectorsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'sector/:id',
    loadChildren: () => import('./pages/sector/sector.module').then( m => m.SectorPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'project/:id',
    loadChildren: () => import('./pages/project/project.module').then( m => m.ProjectPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'recent-updates',
    loadChildren: () => import('./pages/recent-updates/recent-updates.module').then( m => m.RecentUpdatesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'new-projects',
    loadChildren: () => import('./pages/new-projects/new-projects.module').then( m => m.NewProjectsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'projects-following',
    loadChildren: () => import('./pages/projects-following/projects-following.module').then( m => m.ProjectsFollowingPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'projects-working',
    loadChildren: () => import('./pages/projects-working/projects-working.module').then( m => m.ProjectsWorkingPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'company-search',
    loadChildren: () => import('./pages/company/search/search.module').then( m => m.SearchPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'project-search',
    loadChildren: () => import('./pages/projects/search/search.module').then( m => m.SearchPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'saved-search',
    loadChildren: () => import('./pages/projects/saved-search/saved-search.module').then( m => m.SavedSearchPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'company/:id',
    loadChildren: () => import('./pages/company/company/company.module').then( m => m.CompanyPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'contractor-workload',
    loadChildren: () => import('./pages/analyze/contractor-workload/contractor-workload.module').then( m => m.ContractorWorkloadPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'market-overview',
    loadChildren: () => import('./pages/analyze/market-overview/market-overview.module').then( m => m.MarketOverviewPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'epcsuccess-rate',
    loadChildren: () => import('./pages/analyze/epcsuccess-rate/epcsuccess-rate.module').then( m => m.EPCSuccessRatePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'greenfield-brownfield',
    loadChildren: () =>
      import('./pages/analyze/greenfield-brownfield/greenfield-brownfield.module')
        .then( m => m.GreenfieldBrownfieldPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'account',
    loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'support',
    loadChildren: () => import('./pages/support/support.module').then(m => m.SupportModule) ,
    canActivate: [AuthGuard]
  },
  {
    path: 'beta',
    loadChildren: () => import('./pages/beta/beta.module').then( m => m.BetaPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
   {
    path: 'followed-companies',
    loadChildren: () => import('./pages/company/followed-companies/followed-companies.module').then( m => m.FollowedCompaniesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'test',
    loadChildren: () => import('./pages/test/test.module').then( m => m.TestPageModule)
  },
  {
    path: 'search-results/:id',
    loadChildren: () => import('./pages/projects/search-results/search-results.module').then( m => m.SearchResultsPageModule)
  },
    {
    path: 'company-results',
    loadChildren: () => import('./pages/company/company-results/company-results.module').then( m => m.CompanyResultsPageModule)
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
